// @flow
/* global COMMITHASH */

import { getFbpFromCookies } from '@tectonics/analytics/facebook-pixel';
import { type AppValues } from '@tectonics/app-values';
import { type IncomingPayment, getMerchant } from '@tectonics/prs/incoming-payment';
import { getName as getMerchantName, getLookAndFeel, getThemeId } from '@tectonics/prs/merchant';
import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import { getClientId as getGaClientId } from '@tectonics/commons/google-analytics';

export async function metadataOutgoingPaymentMapper(
  userInputValues: UserInputValues,
  incomingPayment: IncomingPayment,
  appValues: AppValues,
): Promise<$Shape<OutgoingPayment>> {
  const merchant = getMerchant(incomingPayment);

  return {
    app_metadata: {
      merchant_name: getMerchantName(merchant),
      current_commit: COMMITHASH,
      look_and_feel: getLookAndFeel(merchant),
      theme: getThemeId(merchant),
    },
    metadata: {
      analytics: buildAnalyticsMetadata(appValues),
      shopify: {
        checkout_token: appValues.shopifyCheckoutToken,
        shop_name: appValues.shopifyCheckoutApiHost,
      },
    },
  };
}

function buildAnalyticsMetadata(appValues: AppValues): Object {
  return {
    google_analytics: buildGoogleAnalyticsMetadata(),
    facebook_pixel: {
      fbp: appValues.shopifyFacebookPixelFbp || getFbpFromCookies(document.cookie),
    },
  };
}

function buildGoogleAnalyticsMetadata(): Object {
  try {
    const gaClientId = getGaClientId();
    return {
      cid: gaClientId,
    };
  } catch(error) {
    return {};
  }
}
